import React from "react";


const VlanTableHeading = ({headers}) => {
  return (
    <table className="table table-bordered mb-0">
      <thead>
        <tr className="text-center">
          <th width="8%">{headers.port}</th>
          <th width="8%">{headers.enable}</th>
          <th width="10%">{headers.member_type} <span className="se-mandatory">*</span>
          </th>
          <th width="12%"> {headers.access_member} <span className="se-mandatory">*</span>
          </th>
          <th width="12%"> {headers.trunk_member}</th>
        </tr>
      </thead>
    </table>
  );
};

export default VlanTableHeading;
